import * as firebase from 'firebase';

const config = {
  apiKey: "AIzaSyChlo-CBbbZWOVzGMzbh_nNU-J3RmaEptA",
  authDomain: "latinxwhocode.firebaseapp.com",
  databaseURL: "https://latinxwhocode.firebaseio.com",
  projectId: "latinxwhocode",
  storageBucket: "latinxwhocode.appspot.com",
  messagingSenderId: "163984988234"
};

firebase.initializeApp(config);

const database = firebase.database();

export { firebase, database as default };






// WEBPACK FOOTER //
// ./src/firebase/firebase.js